module.exports = __webpack_public_path__ + "static/Alvier-3a5fd27406bca3df0e5e2200ad74f985.png";